import { CUSTOM_SUPPORT_TYPES } from 'app-constants'
import get from 'lodash/get'

const getCustomSupport = (state) => {
  const customSupport = get(state, 'interview.jobOpening.company.customSupport', { })
  const companyName = get(state, 'interview.jobOpening.company.name', '')
  const isEnabled = customSupport.enabled
  const customTypesArray = Object.values(CUSTOM_SUPPORT_TYPES)

  if (!isEnabled || !customTypesArray.includes(customSupport.type) || !customSupport.value) {
    return undefined
  }

  return { ...customSupport, companyName }
}

export default getCustomSupport
